<template>
<div class="modal fade" id="modal-new-camp">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title">Создание нового лагеря</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div>En</div>
              <div class="box">
                <div class="box-body">
                  <div class="form-group">
                    <label for="nameEn">{{ $t('trainings.description.name') }}</label>
                    <input v-model="currentCamp.name['en']" type="text" class="form-control" id="nameEn">
                  </div>
                  <div class="form-group">
                    <label>Url</label>
                    <input v-model="currentCamp.urlName" type="text" class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div>RU</div>
              <div class="box">
                <div class="box-body">
                  <div class="form-group">
                    <label for="name">{{ $t('trainings.description.name') }}</label>
                    <input v-model="currentCamp.name['ru']" type="text" class="form-control" id="name">
                  </div>
                   <div class="form-group">
                    <label>Url</label>
                    <input v-model="currentCamp.urlName" type="text" class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
          <button v-on:click="saveCamp" type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddCamp',
  props: {
    countries: Array
  },
  created () {

  },
  data () {
    return {
      currentCamp: {
        name:
            {
              ru: '',
              en: ''
            },
        urlName: ''
      }
    };
  },

  methods: {
    saveCamp: function () {
      var self = this;

      axios.post(
        window.host + '/camps', self.currentCamp)
      // window.rootRoute + '/api/camps', {camp: self.currentCamp})
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');

          document.location.reload(true);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
